// Macrogruppi
import {
  KeyValue,
  MN_DDT_ACQUISTO,
  MN_DDT_VENDITA,
  MN_DOCUMENTI_FISCALI_ACQUISTO,
  MN_DOCUMENTI_FISCALI_VENDITA,
  MN_FATTURE_PROFORMA,
  MN_ORDINI_CLIENTI,
  MN_ORDINI_FORNITORI,
  MN_PREVENTIVI,
  MN_RETTIFICA,
} from '../../types';
import {
  URL_OPERATION_EXP,
  URL_OPERATION_INV,
  URL_OPERATION_XML,
} from '../../../utils';

export const DFVE = 'DFVE';
export const DDTV = 'DDTV';
export const DFAC = 'DFAC';
export const DDTA = 'DDTA';
export const ORDC = 'ORDC';
export const ORDF = 'ORDF';
export const PREV = 'PREV';
export const FAPR = 'FAPR';
export const RETT = 'RETT';

// Sottogruppi
export const DFVE_AUAD = 'DFVE_AUAD';
export const DFVE_AUAI = 'DFVE_AUAI';
export const DFVE_AUAS = 'DFVE_AUAS';
export const DFVE_AUBA = 'DFVE_AUBA';
export const DFVE_AUEU = 'DFVE_AUEU';
export const DFVE_AUOM = 'DFVE_AUOM';
export const DFVE_AURG = 'DFVE_AURG';
export const DFVE_AUSP = 'DFVE_AUSP';
export const DFVE_BEIN = 'DFVE_BEIN';
export const DFVE_ESIV = 'DFVE_ESIV';
export const DFVE_ESVV = 'DFVE_ESVV';
export const DFVE_FAAC = 'DFVE_FAAC';
export const DFVE_FAAP = 'DFVE_FAAP';
export const DFVE_FAD1 = 'DFVE_FAD1';
export const DFVE_FAD2 = 'DFVE_FAD2';
export const DFVE_FASM = 'DFVE_FASM';
export const DFVE_FATT = 'DFVE_FATT';
export const DFVE_NOAC = 'DFVE_NOAC';
export const DFVE_NODE = 'DFVE_NODE';
export const DFVE_PAAC = 'DFVE_PAAC';
export const DFVE_PARC = 'DFVE_PARC';

export const DFAC_SCRI_C = 'DFAC_SCRI_C';
export const DFAC_TEFA_C = 'DFAC_TEFA_C';
export const DFAC_TENA_C = 'DFAC_TENA_C';
export const DFAC_STIP_C = 'DFAC_STIP_C';
export const DFAC_TASS_C = 'DFAC_TASS_C';
export const DFAC_ALTR_C = 'DFAC_ALTR_C';
export const DFAC_STAT_C = 'DFAC_STAT_C';
export const DFAC_FAPR_C = 'DFAC_FAPR_C';
export const DFAC_FAAP = 'DFAC_FAAP';
export const DFAC_FATT = 'DFAC_FATT';
export const DFAC_AUAI = 'DFAC_AUAI';
export const DFAC_FAAP_C = 'DFAC_FAAP_C';
export const DFAC_FATT_C = 'DFAC_FATT_C';
export const DFAC_AUAI_C = 'DFAC_AUAI_C';
export const DFAC_FAAC = 'DFAC_FAAC';
export const DFAC_FAAC_C = 'DFAC_FAAC_C';
export const DFAC_PAAC = 'DFAC_PAAC';
export const DFAC_PAAC_C = 'DFAC_PAAC_C';
export const DFAC_NOAC = 'DFAC_NOAC';
export const DFAC_NOAC_C = 'DFAC_NOAC_C';
export const DFAC_NODE = 'DFAC_NODE';
export const DFAC_NODE_C = 'DFAC_NODE_C';
export const DFAC_PARC = 'DFAC_PARC';
export const DFAC_PARC_C = 'DFAC_PARC_C';
export const DFAC_AURG = 'DFAC_AURG';
export const DFAC_AURG_C = 'DFAC_AURG_C';
export const DFAC_AUAS = 'DFAC_AUAS';
export const DFAC_AUAS_C = 'DFAC_AUAS_C';
export const DFAC_BEIN = 'DFAC_BEIN';
export const DFAC_BEIN_C = 'DFAC_BEIN_C';
export const DFAC_AUEU = 'DFAC_AUEU';
export const DFAC_AUEU_C = 'DFAC_AUEU_C';
export const DFAC_AUAD = 'DFAC_AUAD';
export const DFAC_AUAD_C = 'DFAC_AUAD_C';
export const DFAC_AUSP = 'DFAC_AUSP';
export const DFAC_AUSP_C = 'DFAC_AUSP_C';
export const DFAC_ESIV = 'DFAC_ESIV';
export const DFAC_ESIV_C = 'DFAC_ESIV_C';
export const DFAC_ESVV = 'DFAC_ESVV';
export const DFAC_ESVV_C = 'DFAC_ESVV_C';
export const DFAC_FAD1 = 'DFAC_FAD1';
export const DFAC_FAD1_C = 'DFAC_FAD1_C';
export const DFAC_FAD2 = 'DFAC_FAD2';
export const DFAC_FAD2_C = 'DFAC_FAD2_C';
export const DFAC_AUBA = 'DFAC_AUBA';
export const DFAC_AUBA_C = 'DFAC_AUBA_C';
export const DFAC_AUOM = 'DFAC_AUOM';
export const DFAC_AUOM_C = 'DFAC_AUOM_C';
export const DFAC_FASM = 'DFAC_FASM';
export const DFAC_FASM_C = 'DFAC_FASM_C';

export const ORDC_ORDI = 'ORDC_ORDI';

export const DDTV_DDTV = 'DDTV_DDTV';
export const DDTV_CAIN = 'DDTV_CAIN';
export const DDTV_RESO = 'DDTV_RESO';
export const DDTV_COVI = 'DDTV_COVI';
export const DDTV_CODE = 'DDTV_CODE';
export const DDTV_COVE = 'DDTV_COVE';
export const DDTV_COLA = 'DDTV_COLA';
export const DDTV_TEVE = 'DDTV_TEVE';
export const DDTV_COSC = 'DDTV_COSC';
export const DDTV_RIPA = 'DDTV_RIPA';
export const DDTV_RCLA = 'DDTV_RCLA';
export const DDTV_RCVI = 'DDTV_RCVI';
export const DDTV_RACC = 'DDTV_RACC';
export const DDTV_RSOS = 'DDTV_RSOS';
export const DDTV_RRIP = 'DDTV_RRIP';
export const DDTV_OMAG = 'DDTV_OMAG';
export const DDTA_DDTA = 'DDTA_DDTA';
export const ORDF_ORDI = 'ORDF_ORDI';
export const PREV_PREV = 'PREV_PREV';
export const FAPR_FAPR = 'FAPR_FAPR';
export const RETT_RETT = 'RETT_RETT';

export const DOCUMENTO_FISCALE_VENDITA = 'Documento fiscale di vendita';
export const DDT_VENDITA = 'DDT';
export const DOCUMENTO_FISCALE_ACQUISTO = 'Documento fiscale di acquisto';
export const DDT_FORNITORE = 'DDT Fornitore';
export const ORDINE_CLIENTE = 'Ordine cliente';
export const ORDINE_FORNITORE = 'Ordine fornitore';
export const PREVENTIVO = 'Preventivo';
export const RETTIFICA = 'Documento di rettifica';
export const FATTURA_PROFORMA = 'Fattura proforma';
export const FATTURA_VENDITA = 'Fattura di vendita';
export const FATTURA_ACQUISTO = 'Fattura di acquisto';
export const FATTURA_ACCONTO = 'Fattura acconto';
export const FATTURA_ACCOMPAGNATORIA = 'Fattura accompagnatoria';
export const AUTOFATTURA_ACQUISTI_AGRICOLA =
  'Autofattura acquisti impresa agricola';
export const ACCONTO_PARCELLA = 'Acconto parcella';
export const NOTA_ACCREDITO_CLIENTE = 'Nota di accredito cliente';
export const NOTA_DEBITO_CLIENTE = 'Nota di debito cliente';
export const PARCELLA = 'Parcella';
export const AUTOFATTURA_REVERSE_CHANGE = 'Autofattura reverse charge';
export const AUTOFATTURA_ACQ_SERVIZI_ESTERO =
  'Autofattura acquisto servizi estero';
export const INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI =
  'Integrazione acquisti beni intracomunitari';
export const AUTOFATTURA_EXTRAUE = 'Autofattura per extra UE';
export const AUTOFATTURA_AUTO_DENUNCIA = 'Autofattura per auto denuncia';
export const AUTOFATTURA_SPLAFONAMENTO = 'Autofattura splafonamento';
export const ESPORTAZIONE_BENI_DEPOSITO_IVA = 'Estrazione beni da deposito iva';
export const ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA =
  'Estrazione beni da deposito iva con versamento iva';
export const FATTURA_DIFFERITA = 'Fattura differita';
export const FATTURA_DIFFERITA_B = 'Fattura differita (lett.B)';
export const CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI =
  'Cessione di beni ammortizzabili e passaggi interni';
export const AUTOFATTURA_OMAGGI_AUTOCONSUMO =
  'Autofattura per omaggi o autoconsumo';
export const ACQUISTI_SAN_MARINO_IVA = 'Acquisti da San Marino con IVA';
export const NOTA_ACCREDITO_FORNITORE = 'Nota di accredito fornitore';
export const NOTA_DEBITO_FORNITORE = 'Nota di debito fornitore';
export const STIPENDIO = 'Stipendio';
export const IMPOSTE_TRIBUTI = 'Imposte e tributi';
export const FATTURA_TEMPORANEA = 'Fattura temporanea';
export const SCONTRINI_RICEVUTE = 'Scontrini/Ricevute';
export const DDT_RESO_CANTIERE = 'DDT rientro da cantiere';
export const DDT_TRASPORTO_CANTIERE = 'DDT trasporto in cantiere';
export const DDT_CONTO_VISIONE = 'DDT di conto visione';
export const DDT_CONTO_DEPOSITO = 'DDT di conto deposito';
export const DDT_CONTO_VENDITA = 'DDT conto estimatorio/vendita';
export const DDT_CONTO_LAVORAZIONE = 'DDT di conto lavorazione';
export const DDT_TENTATA_VENDITA = 'DDT di tentata vendita';
export const DDT_CONTO_SCAMBIO = 'DDT conto scambio';
export const DDT_RIPARAZIONE = 'DDT di riparazione';
export const DDT_RESO_CONTO_LAVORAZIONE = 'DDT di reso da conto lavorazione';
export const DDT_RESO_CONTO_VISIONE = 'DDT di reso da conto visione';
export const DDT_RESO_PER_ACCREDITO = 'DDT di reso per accredito';
export const DDT_RESO_PER_SOSTITUZIONE = 'DDT di reso per sostituzione';
export const DDT_RESO_DA_RIPARAZIONE = 'DDT di reso da riparazione';
export const DDT_OMAGGIO = 'DDT di omaggio';
export const AUTOFATTURA = 'Autofattura';
export const NOTA_ACCREDITO = 'Nota di accredito';
export const NOTA_ACCREDITO_TEMPORANEA = 'Nota di accredito temporanea';
export const ALTRO = 'Altro';

export const TD01 = 'TD01';
export const TD02 = 'TD02';
export const TD03 = 'TD03';
export const TD04 = 'TD04';
export const TD05 = 'TD05';
export const TD06 = 'TD06';
export const TD16 = 'TD16';
export const TD17 = 'TD17';
export const TD18 = 'TD18';
export const TD19 = 'TD19';
export const TD20 = 'TD20';
export const TD21 = 'TD21';
export const TD22 = 'TD22';
export const TD23 = 'TD23';
export const TD24 = 'TD24';
export const TD25 = 'TD25';
export const TD26 = 'TD26';
export const TD27 = 'TD27';
export const TD28 = 'TD28';

export const DOC_IDS = [
  DFVE,
  DDTV,
  DFAC,
  DDTA,
  ORDC,
  ORDF,
  PREV,
  FAPR,
  RETT,
] as const;

export type DocID = (typeof DOC_IDS)[number];

export const DocumentiMacroGruppi: Record<DocID, string> = {
  [DFVE]: MN_DOCUMENTI_FISCALI_VENDITA,
  [DDTV]: MN_DDT_VENDITA,
  [DFAC]: MN_DOCUMENTI_FISCALI_ACQUISTO,
  [DDTA]: MN_DDT_ACQUISTO,
  [ORDC]: MN_ORDINI_CLIENTI,
  [ORDF]: MN_ORDINI_FORNITORI,
  [PREV]: MN_PREVENTIVI,
  [FAPR]: MN_FATTURE_PROFORMA,
  [RETT]: MN_RETTIFICA,
};

export const TipoDocumento: KeyValue[] = [
  { id: DFVE, descrizione: DOCUMENTO_FISCALE_VENDITA },
  { id: DDTV, descrizione: DDT_VENDITA },
  { id: DFAC, descrizione: DOCUMENTO_FISCALE_ACQUISTO },
  { id: DDTA, descrizione: DDT_FORNITORE },
  { id: ORDC, descrizione: ORDINE_CLIENTE },
  { id: ORDF, descrizione: ORDINE_FORNITORE },
  { id: PREV, descrizione: PREVENTIVO },
  { id: RETT, descrizione: RETTIFICA },
  { id: FAPR, descrizione: FATTURA_PROFORMA },
];

export const TipoDocumentoDistinct: KeyValue[] = [
  { id: DFVE, descrizione: DOCUMENTO_FISCALE_VENDITA },
  { id: DDTV, descrizione: DDT_VENDITA },
  { id: DFAC, descrizione: 'Documento fiscale di acquisto (elettronico)' },
  { id: DFAC + '_C', descrizione: 'Documento fiscale di acquisto (cartaceo)' },
  { id: DDTA, descrizione: DDT_FORNITORE },
  { id: ORDC, descrizione: ORDINE_CLIENTE },
  { id: ORDF, descrizione: ORDINE_FORNITORE },
  { id: PREV, descrizione: PREVENTIVO },
  { id: RETT, descrizione: RETTIFICA },
  { id: FAPR, descrizione: FATTURA_PROFORMA },
];

export const TipiDocumentoVendita: string[] = [DFVE, DDTV, ORDC, PREV, FAPR];

export const TipiDocumentoAcquisto: string[] = [DFAC, ORDF, DDTA, RETT];

export const DocumentiSottoGruppi: KeyValue[] = [
  { id: DFVE_FATT, descrizione: FATTURA_VENDITA },
  { id: DFVE_FAAC, descrizione: FATTURA_ACCONTO },
  { id: DFVE_FAAP, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFVE_AUAI, descrizione: AUTOFATTURA_ACQUISTI_AGRICOLA },
  { id: DFVE_PAAC, descrizione: ACCONTO_PARCELLA },
  { id: DFVE_NOAC, descrizione: NOTA_ACCREDITO_CLIENTE },
  { id: DFVE_NODE, descrizione: NOTA_DEBITO_CLIENTE },
  { id: DFVE_PARC, descrizione: PARCELLA },
  { id: DFVE_AURG, descrizione: AUTOFATTURA_REVERSE_CHANGE },
  { id: DFVE_AUAS, descrizione: AUTOFATTURA_ACQ_SERVIZI_ESTERO },
  { id: DFVE_BEIN, descrizione: INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI },
  { id: DFVE_AUEU, descrizione: AUTOFATTURA_EXTRAUE },
  { id: DFVE_AUAD, descrizione: AUTOFATTURA_AUTO_DENUNCIA },
  { id: DFVE_AUSP, descrizione: AUTOFATTURA_SPLAFONAMENTO },
  { id: DFVE_ESIV, descrizione: ESPORTAZIONE_BENI_DEPOSITO_IVA },
  { id: DFVE_ESVV, descrizione: ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA },
  { id: DFVE_FAD1, descrizione: FATTURA_DIFFERITA },
  { id: DFVE_FAD2, descrizione: FATTURA_DIFFERITA_B },
  { id: DFVE_AUBA, descrizione: CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI },
  { id: DFVE_AUOM, descrizione: AUTOFATTURA_OMAGGI_AUTOCONSUMO },
  { id: DFVE_FASM, descrizione: ACQUISTI_SAN_MARINO_IVA },

  { id: DFAC_ALTR_C, descrizione: ALTRO },
  { id: DFAC_AUAD_C, descrizione: AUTOFATTURA_AUTO_DENUNCIA },
  { id: DFAC_AUAD, descrizione: AUTOFATTURA_AUTO_DENUNCIA },
  { id: DFAC_AUAI_C, descrizione: AUTOFATTURA_ACQUISTI_AGRICOLA },
  { id: DFAC_AUAI, descrizione: AUTOFATTURA_ACQUISTI_AGRICOLA },
  { id: DFAC_AUAS_C, descrizione: AUTOFATTURA_ACQ_SERVIZI_ESTERO },
  { id: DFAC_AUAS, descrizione: AUTOFATTURA_ACQ_SERVIZI_ESTERO },
  {
    id: DFAC_AUBA_C,
    descrizione: CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI,
  },
  { id: DFAC_AUBA, descrizione: CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI },
  { id: DFAC_AUEU_C, descrizione: AUTOFATTURA_EXTRAUE },
  { id: DFAC_AUEU, descrizione: AUTOFATTURA_EXTRAUE },
  { id: DFAC_AUOM_C, descrizione: AUTOFATTURA_OMAGGI_AUTOCONSUMO },
  { id: DFAC_AUOM, descrizione: AUTOFATTURA_OMAGGI_AUTOCONSUMO },
  { id: DFAC_AURG_C, descrizione: AUTOFATTURA_REVERSE_CHANGE },
  { id: DFAC_AURG, descrizione: AUTOFATTURA_REVERSE_CHANGE },
  { id: DFAC_AUSP_C, descrizione: AUTOFATTURA_SPLAFONAMENTO },
  { id: DFAC_AUSP, descrizione: AUTOFATTURA_SPLAFONAMENTO },
  { id: DFAC_BEIN_C, descrizione: INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI },
  { id: DFAC_BEIN, descrizione: INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI },
  { id: DFAC_ESIV_C, descrizione: ESPORTAZIONE_BENI_DEPOSITO_IVA },
  { id: DFAC_ESIV, descrizione: ESPORTAZIONE_BENI_DEPOSITO_IVA },
  { id: DFAC_ESVV_C, descrizione: ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA },
  { id: DFAC_ESVV, descrizione: ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA },
  { id: DFAC_FAAC_C, descrizione: FATTURA_ACCONTO },
  { id: DFAC_FAAC, descrizione: FATTURA_ACCONTO },
  { id: DFAC_FAAP_C, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFAC_FAAP, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFAC_FAD1_C, descrizione: FATTURA_DIFFERITA },
  { id: DFAC_FAD1, descrizione: FATTURA_DIFFERITA },
  { id: DFAC_FAD2_C, descrizione: FATTURA_DIFFERITA_B },
  { id: DFAC_FAD2, descrizione: FATTURA_DIFFERITA_B },
  { id: DFAC_FAPR_C, descrizione: FATTURA_PROFORMA },
  { id: DFAC_FASM_C, descrizione: ACQUISTI_SAN_MARINO_IVA },
  { id: DFAC_FASM, descrizione: ACQUISTI_SAN_MARINO_IVA },
  { id: DFAC_FATT_C, descrizione: FATTURA_ACQUISTO },
  { id: DFAC_FATT, descrizione: FATTURA_ACQUISTO },
  { id: DFAC_NOAC_C, descrizione: NOTA_ACCREDITO_FORNITORE },
  { id: DFAC_NOAC, descrizione: NOTA_ACCREDITO_FORNITORE },
  { id: DFAC_NODE_C, descrizione: NOTA_DEBITO_FORNITORE },
  { id: DFAC_NODE, descrizione: NOTA_DEBITO_FORNITORE },
  { id: DFAC_PAAC_C, descrizione: ACCONTO_PARCELLA },
  { id: DFAC_PAAC, descrizione: ACCONTO_PARCELLA },
  { id: DFAC_PARC_C, descrizione: PARCELLA },
  { id: DFAC_PARC, descrizione: PARCELLA },
  { id: DFAC_STIP_C, descrizione: STIPENDIO },
  { id: DFAC_TASS_C, descrizione: IMPOSTE_TRIBUTI },
  { id: DFAC_TEFA_C, descrizione: FATTURA_TEMPORANEA },
  { id: DFAC_TENA_C, descrizione: NOTA_ACCREDITO_TEMPORANEA },
  { id: DFAC_SCRI_C, descrizione: SCONTRINI_RICEVUTE },
  { id: ORDC_ORDI, descrizione: ORDINE_CLIENTE },
  { id: DDTV_DDTV, descrizione: DDT_VENDITA },
  { id: DDTV_CAIN, descrizione: DDT_TRASPORTO_CANTIERE },
  { id: DDTV_RESO, descrizione: DDT_RESO_CANTIERE },
  { id: DDTV_COVI, descrizione: DDT_CONTO_VISIONE },
  { id: DDTV_CODE, descrizione: DDT_CONTO_DEPOSITO },
  { id: DDTV_COVE, descrizione: DDT_CONTO_VENDITA },
  { id: DDTV_COLA, descrizione: DDT_CONTO_LAVORAZIONE },
  { id: DDTV_TEVE, descrizione: DDT_TENTATA_VENDITA },
  { id: DDTV_COSC, descrizione: DDT_CONTO_SCAMBIO },
  { id: DDTV_RIPA, descrizione: DDT_RIPARAZIONE },
  { id: DDTV_RCLA, descrizione: DDT_RESO_CONTO_LAVORAZIONE },
  { id: DDTV_RCVI, descrizione: DDT_RESO_CONTO_VISIONE },
  { id: DDTV_RACC, descrizione: DDT_RESO_PER_ACCREDITO },
  { id: DDTV_RSOS, descrizione: DDT_RESO_PER_SOSTITUZIONE },
  { id: DDTV_RRIP, descrizione: DDT_RESO_DA_RIPARAZIONE },
  { id: DDTV_OMAG, descrizione: DDT_OMAGGIO },
  { id: DDTA_DDTA, descrizione: DDT_FORNITORE },
  { id: ORDF_ORDI, descrizione: ORDINE_FORNITORE },
  { id: PREV_PREV, descrizione: PREVENTIVO },
  { id: RETT_RETT, descrizione: RETTIFICA },
  { id: FAPR_FAPR, descrizione: FATTURA_PROFORMA },
];

export const DocumentiSottoGruppiSimplifyAutofatture: KeyValue[] = [
  { id: DFVE_FATT, descrizione: FATTURA_VENDITA },
  { id: DFVE_FAAC, descrizione: FATTURA_ACCONTO },
  { id: DFVE_FAAP, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFVE_AUAI, descrizione: AUTOFATTURA },
  { id: DFVE_PAAC, descrizione: ACCONTO_PARCELLA },
  { id: DFVE_NOAC, descrizione: NOTA_ACCREDITO_CLIENTE },
  { id: DFVE_NODE, descrizione: NOTA_DEBITO_CLIENTE },
  { id: DFVE_PARC, descrizione: PARCELLA },
  { id: DFVE_AURG, descrizione: AUTOFATTURA },
  { id: DFVE_AUAS, descrizione: AUTOFATTURA },
  { id: DFVE_BEIN, descrizione: AUTOFATTURA },
  { id: DFVE_AUEU, descrizione: AUTOFATTURA },
  { id: DFVE_AUAD, descrizione: AUTOFATTURA },
  { id: DFVE_AUSP, descrizione: AUTOFATTURA },
  { id: DFVE_ESIV, descrizione: AUTOFATTURA },
  { id: DFVE_ESVV, descrizione: AUTOFATTURA },
  { id: DFVE_FAD1, descrizione: FATTURA_DIFFERITA },
  { id: DFVE_FAD2, descrizione: FATTURA_DIFFERITA_B },
  { id: DFVE_AUBA, descrizione: AUTOFATTURA },
  { id: DFVE_AUOM, descrizione: AUTOFATTURA },
  { id: DFVE_FASM, descrizione: AUTOFATTURA },

  { id: DFAC_ALTR_C, descrizione: ALTRO },
  { id: DFAC_AUAD_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUAD, descrizione: AUTOFATTURA },
  { id: DFAC_AUAI_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUAI, descrizione: AUTOFATTURA },
  { id: DFAC_AUAS_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUAS, descrizione: AUTOFATTURA },
  { id: DFAC_AUBA_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUBA, descrizione: AUTOFATTURA },
  { id: DFAC_AUEU_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUEU, descrizione: AUTOFATTURA },
  { id: DFAC_AUOM_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUOM, descrizione: AUTOFATTURA },
  { id: DFAC_AURG_C, descrizione: AUTOFATTURA },
  { id: DFAC_AURG, descrizione: AUTOFATTURA },
  { id: DFAC_AUSP_C, descrizione: AUTOFATTURA },
  { id: DFAC_AUSP, descrizione: AUTOFATTURA },
  { id: DFAC_BEIN_C, descrizione: AUTOFATTURA },
  { id: DFAC_BEIN, descrizione: AUTOFATTURA },
  { id: DFAC_ESIV_C, descrizione: AUTOFATTURA },
  { id: DFAC_ESIV, descrizione: AUTOFATTURA },
  { id: DFAC_ESVV_C, descrizione: AUTOFATTURA },
  { id: DFAC_ESVV, descrizione: AUTOFATTURA },
  { id: DFAC_FAAC_C, descrizione: FATTURA_ACCONTO },
  { id: DFAC_FAAC, descrizione: FATTURA_ACCONTO },
  { id: DFAC_FAAP_C, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFAC_FAAP, descrizione: FATTURA_ACCOMPAGNATORIA },
  { id: DFAC_FAD1_C, descrizione: FATTURA_DIFFERITA },
  { id: DFAC_FAD1, descrizione: FATTURA_DIFFERITA },
  { id: DFAC_FAD2_C, descrizione: FATTURA_DIFFERITA_B },
  { id: DFAC_FAD2, descrizione: FATTURA_DIFFERITA_B },
  { id: DFAC_FAPR_C, descrizione: FATTURA_PROFORMA },
  { id: DFAC_FASM_C, descrizione: AUTOFATTURA },
  { id: DFAC_FASM, descrizione: AUTOFATTURA },
  { id: DFAC_FATT_C, descrizione: FATTURA_ACQUISTO },
  { id: DFAC_FATT, descrizione: FATTURA_ACQUISTO },
  { id: DFAC_NOAC_C, descrizione: NOTA_ACCREDITO },
  { id: DFAC_NOAC, descrizione: NOTA_ACCREDITO_FORNITORE },
  { id: DFAC_NODE_C, descrizione: NOTA_DEBITO_FORNITORE },
  { id: DFAC_NODE, descrizione: NOTA_DEBITO_FORNITORE },
  { id: DFAC_PAAC_C, descrizione: ACCONTO_PARCELLA },
  { id: DFAC_PAAC, descrizione: ACCONTO_PARCELLA },
  { id: DFAC_PARC_C, descrizione: PARCELLA },
  { id: DFAC_PARC, descrizione: PARCELLA },
  { id: DFAC_STIP_C, descrizione: STIPENDIO },
  { id: DFAC_TASS_C, descrizione: IMPOSTE_TRIBUTI },
  { id: DFAC_TEFA_C, descrizione: FATTURA_TEMPORANEA },
  { id: DFAC_TENA_C, descrizione: NOTA_ACCREDITO_TEMPORANEA },
  { id: DFAC_SCRI_C, descrizione: SCONTRINI_RICEVUTE },

  { id: ORDC_ORDI, descrizione: ORDINE_CLIENTE },
  { id: DDTV_DDTV, descrizione: DDT_VENDITA },
  { id: DDTV_CAIN, descrizione: DDT_TRASPORTO_CANTIERE },
  { id: DDTV_RESO, descrizione: DDT_RESO_CANTIERE },
  { id: DDTV_COVI, descrizione: DDT_CONTO_VISIONE },
  { id: DDTV_CODE, descrizione: DDT_CONTO_DEPOSITO },
  { id: DDTV_COVE, descrizione: DDT_CONTO_VENDITA },
  { id: DDTV_COLA, descrizione: DDT_CONTO_LAVORAZIONE },
  { id: DDTV_TEVE, descrizione: DDT_TENTATA_VENDITA },
  { id: DDTV_COSC, descrizione: DDT_CONTO_SCAMBIO },
  { id: DDTV_RIPA, descrizione: DDT_RIPARAZIONE },
  { id: DDTV_RCLA, descrizione: DDT_RESO_CONTO_LAVORAZIONE },
  { id: DDTV_RCVI, descrizione: DDT_RESO_CONTO_VISIONE },
  { id: DDTV_RACC, descrizione: DDT_RESO_PER_ACCREDITO },
  { id: DDTV_RSOS, descrizione: DDT_RESO_PER_SOSTITUZIONE },
  { id: DDTV_RRIP, descrizione: DDT_RESO_DA_RIPARAZIONE },
  { id: DDTV_OMAG, descrizione: DDT_OMAGGIO },
  { id: DDTA_DDTA, descrizione: DDT_FORNITORE },
  { id: ORDF_ORDI, descrizione: ORDINE_FORNITORE },
  { id: PREV_PREV, descrizione: PREVENTIVO },
  { id: RETT_RETT, descrizione: RETTIFICA },
  { id: FAPR_FAPR, descrizione: FATTURA_PROFORMA },
];

export const DocumentiSottoGruppiSiglaFE: KeyValue[] = [
  { id: DFVE_FATT, descrizione: `[${TD01}] ${FATTURA_VENDITA}` },
  { id: DFVE_FAAC, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFVE_FAAP, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFVE_AUAI, descrizione: `[${TD01}] ${AUTOFATTURA_ACQUISTI_AGRICOLA}` },
  { id: DFVE_PAAC, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFVE_NOAC, descrizione: `[${TD04}] ${NOTA_ACCREDITO_CLIENTE}` },
  { id: DFVE_NODE, descrizione: `[${TD05}] ${NOTA_DEBITO_CLIENTE}` },
  { id: DFVE_PARC, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFVE_AURG, descrizione: `[${TD16}] ${AUTOFATTURA_REVERSE_CHANGE}` },
  { id: DFVE_AUAS, descrizione: `[${TD17}] ${AUTOFATTURA_ACQ_SERVIZI_ESTERO}` },
  {
    id: DFVE_BEIN,
    descrizione: `[${TD18}] ${INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI}`,
  },
  { id: DFVE_AUEU, descrizione: `[${TD19}] ${AUTOFATTURA_EXTRAUE}` },
  { id: DFVE_AUAD, descrizione: `[${TD20}] ${AUTOFATTURA_AUTO_DENUNCIA}` },
  { id: DFVE_AUSP, descrizione: `[${TD21}] ${AUTOFATTURA_SPLAFONAMENTO}` },
  { id: DFVE_ESIV, descrizione: `[${TD22}] ${ESPORTAZIONE_BENI_DEPOSITO_IVA}` },
  {
    id: DFVE_ESVV,
    descrizione: `[${TD23}] ${ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA}`,
  },
  { id: DFVE_FAD1, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFVE_FAD2, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
  {
    id: DFVE_AUBA,
    descrizione: `[${TD26}] ${CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI}`,
  },
  { id: DFVE_AUOM, descrizione: `[${TD27}] ${AUTOFATTURA_OMAGGI_AUTOCONSUMO}` },
  { id: DFVE_FASM, descrizione: `[${TD28}] ${ACQUISTI_SAN_MARINO_IVA}` },

  { id: DFAC_TEFA_C, descrizione: FATTURA_TEMPORANEA },
  { id: DFAC_TENA_C, descrizione: NOTA_ACCREDITO_TEMPORANEA },
  { id: DFAC_STIP_C, descrizione: STIPENDIO },
  { id: DFAC_TASS_C, descrizione: IMPOSTE_TRIBUTI },
  { id: DFAC_ALTR_C, descrizione: ALTRO },
  { id: DFAC_FAPR_C, descrizione: FATTURA_PROFORMA },
  { id: DFAC_SCRI_C, descrizione: SCONTRINI_RICEVUTE },
  { id: DFAC_FAAP, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFAC_FATT, descrizione: `[${TD01}] ${FATTURA_ACQUISTO}` },
  { id: DFAC_AUAI, descrizione: `[${TD01}] ${AUTOFATTURA_ACQUISTI_AGRICOLA}` },
  { id: DFAC_FAAP_C, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFAC_FATT_C, descrizione: `[${TD01}] ${FATTURA_ACQUISTO}` },
  {
    id: DFAC_AUAI_C,
    descrizione: `[${TD01}] ${AUTOFATTURA_ACQUISTI_AGRICOLA}`,
  },
  { id: DFAC_FAAC, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFAC_FAAC_C, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFAC_PAAC, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFAC_PAAC_C, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFAC_NOAC, descrizione: `[${TD04}] ${NOTA_ACCREDITO_FORNITORE}` },
  { id: DFAC_NOAC_C, descrizione: `[${TD04}] ${NOTA_ACCREDITO_FORNITORE}` },
  { id: DFAC_NODE, descrizione: `[${TD05}] ${NOTA_DEBITO_FORNITORE}` },
  { id: DFAC_NODE_C, descrizione: `[${TD05}] ${NOTA_DEBITO_FORNITORE}` },
  { id: DFAC_PARC, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFAC_PARC_C, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFAC_AURG, descrizione: `[${TD16}] ${AUTOFATTURA_REVERSE_CHANGE}` },
  { id: DFAC_AURG_C, descrizione: `[${TD16}] ${AUTOFATTURA_REVERSE_CHANGE}` },
  { id: DFAC_AUAS, descrizione: `[${TD17}] ${AUTOFATTURA_ACQ_SERVIZI_ESTERO}` },
  {
    id: DFAC_AUAS_C,
    descrizione: `[${TD17}] ${AUTOFATTURA_ACQ_SERVIZI_ESTERO}`,
  },
  {
    id: DFAC_BEIN,
    descrizione: `[${TD18}] ${INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI}`,
  },
  {
    id: DFAC_BEIN_C,
    descrizione: `[${TD18}] ${INTEGRAZIONE_ACQUISTI_BENI_INTRACOMUNITARI}`,
  },
  { id: DFAC_AUEU, descrizione: `[${TD19}] ${AUTOFATTURA_EXTRAUE}` },
  { id: DFAC_AUEU_C, descrizione: `[${TD19}] ${AUTOFATTURA_EXTRAUE}` },
  { id: DFAC_AUAD, descrizione: `[${TD20}] ${AUTOFATTURA_AUTO_DENUNCIA}` },
  { id: DFAC_AUAD_C, descrizione: `[${TD20}] ${AUTOFATTURA_AUTO_DENUNCIA}` },
  { id: DFAC_AUSP, descrizione: `[${TD21}] ${AUTOFATTURA_SPLAFONAMENTO}` },
  { id: DFAC_AUSP_C, descrizione: `[${TD21}] ${AUTOFATTURA_SPLAFONAMENTO}` },
  { id: DFAC_ESIV, descrizione: `[${TD22}] ${ESPORTAZIONE_BENI_DEPOSITO_IVA}` },
  {
    id: DFAC_ESIV_C,
    descrizione: `[${TD22}] ${ESPORTAZIONE_BENI_DEPOSITO_IVA}`,
  },
  {
    id: DFAC_ESVV,
    descrizione: `[${TD23}] ${ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA}`,
  },
  {
    id: DFAC_ESVV_C,
    descrizione: `[${TD23}] ${ESTRAZIONE_BENI_DEPOSITO_IVA_VERSAMENTO_IVA}`,
  },
  { id: DFAC_FAD1, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFAC_FAD1_C, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFAC_FAD2, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
  { id: DFAC_FAD2_C, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
  {
    id: DFAC_AUBA,
    descrizione: `[${TD26}] ${CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI}`,
  },
  {
    id: DFAC_AUBA_C,
    descrizione: `[${TD26}] ${CESSIONE_BENI_AMMORTIZZABILI_PASSAGGI_INTERNI}`,
  },
  { id: DFAC_AUOM, descrizione: `[${TD27}] ${AUTOFATTURA_OMAGGI_AUTOCONSUMO}` },
  {
    id: DFAC_AUOM_C,
    descrizione: `[${TD27}] ${AUTOFATTURA_OMAGGI_AUTOCONSUMO}`,
  },
  { id: DFAC_FASM, descrizione: `[${TD28}] ${ACQUISTI_SAN_MARINO_IVA}` },
  { id: DFAC_FASM_C, descrizione: `[${TD28}] ${ACQUISTI_SAN_MARINO_IVA}` },
  { id: ORDC_ORDI, descrizione: ORDINE_CLIENTE },
  { id: DDTV_DDTV, descrizione: DDT_VENDITA },
  { id: DDTV_CAIN, descrizione: DDT_TRASPORTO_CANTIERE },
  { id: DDTV_RESO, descrizione: DDT_RESO_CANTIERE },
  { id: DDTV_COVI, descrizione: DDT_CONTO_VISIONE },
  { id: DDTV_CODE, descrizione: DDT_CONTO_DEPOSITO },
  { id: DDTV_COVE, descrizione: DDT_CONTO_VENDITA },
  { id: DDTV_COLA, descrizione: DDT_CONTO_LAVORAZIONE },
  { id: DDTV_TEVE, descrizione: DDT_TENTATA_VENDITA },
  { id: DDTV_COSC, descrizione: DDT_CONTO_SCAMBIO },
  { id: DDTV_RIPA, descrizione: DDT_RIPARAZIONE },
  { id: DDTV_RCLA, descrizione: DDT_RESO_CONTO_LAVORAZIONE },
  { id: DDTV_RCVI, descrizione: DDT_RESO_CONTO_VISIONE },
  { id: DDTV_RACC, descrizione: DDT_RESO_PER_ACCREDITO },
  { id: DDTV_RSOS, descrizione: DDT_RESO_PER_SOSTITUZIONE },
  { id: DDTV_RRIP, descrizione: DDT_RESO_DA_RIPARAZIONE },
  { id: DDTV_OMAG, descrizione: DDT_OMAGGIO },
  { id: DDTA_DDTA, descrizione: DDT_FORNITORE },
  { id: ORDF_ORDI, descrizione: ORDINE_FORNITORE },
  { id: PREV_PREV, descrizione: PREVENTIVO },
  { id: RETT_RETT, descrizione: RETTIFICA },
  { id: FAPR_FAPR, descrizione: FATTURA_PROFORMA },
];

export const DocumentiSottoGruppiVenditaCommesse = [
  DFVE_FATT,
  DFVE_FAAC,
  DFVE_FAAP,
  DFVE_PAAC,
  DFVE_NOAC,
  DFVE_NODE,
  DFVE_PARC,
  DFVE_FAD1,
  DFVE_FAD2,
];

export const DocumentiSottoGruppiVenditaFatturazioneCommessa = [
  DFVE_FATT,
  DFVE_FAAC,
  DFVE_FAAP,
  DFVE_PAAC,
  DFVE_NODE,
  DFVE_PARC,
  DFVE_FAD1,
  DFVE_FAD2,
];

export const DocumentiSottoGruppiVenditaCommesseKeyValue: KeyValue[] = [
  { id: DFVE_FATT, descrizione: `[${TD01}] ${FATTURA_VENDITA}` },
  { id: DFVE_FAAC, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFVE_FAAP, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFVE_PAAC, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFVE_NOAC, descrizione: `[${TD04}] ${NOTA_ACCREDITO_CLIENTE}` },
  { id: DFVE_NODE, descrizione: `[${TD05}] ${NOTA_DEBITO_CLIENTE}` },
  { id: DFVE_PARC, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFVE_FAD1, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFVE_FAD2, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
];

export const DocumentiSottoGruppiAcquistoCommesse = [
  DFAC_FATT,
  DFAC_FAAC,
  DFAC_FAAP,
  DFAC_NOAC,
  DFAC_NODE,
  DFAC_FAD1,
  DFAC_FAD2,
  DFAC_PARC,
  DFAC_PAAC,
  DFAC_FATT_C,
  DFAC_FAAC_C,
  DFAC_FAAP_C,
  DFAC_NOAC_C,
  DFAC_NODE_C,
  DFAC_FAD1_C,
  DFAC_FAD2_C,
  DFAC_PARC_C,
  DFAC_PAAC_C,
  DFAC_FAPR_C,
  DFAC_TEFA_C,
  DFAC_TENA_C,
  DFAC_SCRI_C,
  DFAC_ALTR_C,
];

export const DocumentiSottoGruppiAcquistoCommesseKeyValue: KeyValue[] = [
  { id: DFAC_FATT, descrizione: `[${TD01}] ${FATTURA_ACQUISTO}` },
  { id: DFAC_FAAC, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFAC_FAAP, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFAC_NOAC, descrizione: `[${TD04}] ${NOTA_ACCREDITO_FORNITORE}` },
  { id: DFAC_NODE, descrizione: `[${TD05}] ${NOTA_DEBITO_FORNITORE}` },
  { id: DFAC_FAD1, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFAC_FAD2, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
  { id: DFAC_PARC, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFAC_PAAC, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFAC_FATT_C, descrizione: `[${TD01}] ${FATTURA_ACQUISTO}` },
  { id: DFAC_FAAC_C, descrizione: `[${TD02}] ${FATTURA_ACCONTO}` },
  { id: DFAC_FAAP_C, descrizione: `[${TD01}] ${FATTURA_ACCOMPAGNATORIA}` },
  { id: DFAC_NOAC_C, descrizione: `[${TD04}] ${NOTA_ACCREDITO_FORNITORE}` },
  { id: DFAC_NODE_C, descrizione: `[${TD05}] ${NOTA_DEBITO_FORNITORE}` },
  { id: DFAC_FAD1_C, descrizione: `[${TD24}] ${FATTURA_DIFFERITA}` },
  { id: DFAC_FAD2_C, descrizione: `[${TD25}] ${FATTURA_DIFFERITA_B}` },
  { id: DFAC_PARC_C, descrizione: `[${TD06}] ${PARCELLA}` },
  { id: DFAC_PAAC_C, descrizione: `[${TD03}] ${ACCONTO_PARCELLA}` },
  { id: DFAC_FAPR_C, descrizione: FATTURA_PROFORMA },
  { id: DFAC_TEFA_C, descrizione: FATTURA_TEMPORANEA },
  { id: DFAC_TENA_C, descrizione: NOTA_ACCREDITO_TEMPORANEA },
  { id: DFAC_SCRI_C, descrizione: SCONTRINI_RICEVUTE },
  { id: DFAC_ALTR_C, descrizione: ALTRO },
];

export const DFVE_INVERSIONE_XML = [
  DFVE_AUAD,
  DFVE_AUEU,
  DFVE_AURG,
  DFVE_AUAS,
  DFVE_BEIN,
  DFVE_ESIV,
  DFVE_ESVV,
  DFVE_FASM,
  DFVE_AUAI,
];

export const DocumentiTipoAde: KeyValue[] = [
  { id: '', descrizione: '' },
  { id: TD01, descrizione: TD01 },
  { id: TD02, descrizione: TD02 },
  { id: TD03, descrizione: TD03 },
  { id: TD04, descrizione: TD04 },
  { id: TD05, descrizione: TD05 },
  { id: TD06, descrizione: TD06 },
  { id: TD16, descrizione: TD16 },
  { id: TD17, descrizione: TD17 },
  { id: TD18, descrizione: TD18 },
  { id: TD19, descrizione: TD19 },
  { id: TD20, descrizione: TD20 },
  { id: TD21, descrizione: TD21 },
  { id: TD22, descrizione: TD22 },
  { id: TD23, descrizione: TD23 },
  { id: TD24, descrizione: TD24 },
  { id: TD25, descrizione: TD25 },
  { id: TD26, descrizione: TD26 },
  { id: TD27, descrizione: TD27 },
  { id: TD28, descrizione: TD28 },
];

export const RitenutaTipo: KeyValue[] = [
  { id: 'RT01', descrizione: 'Ritenuta persone fisiche' },
  { id: 'RT02', descrizione: 'Ritenuta persone giuridiche' },
  { id: 'RT03', descrizione: 'Contributo INPS' },
  { id: 'RT05', descrizione: 'Contributo ENPAM' },
  { id: 'RT06', descrizione: 'Altro contributo previdenziale' },
];

export const EnasarcoTipo: KeyValue[] = [
  { id: 'RT04', descrizione: 'Contributo ENASARCO' },
];

export const CassaPrevidenzialeTipo: KeyValue[] = [
  {
    id: 'TC01',
    descrizione:
      'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
  },
  { id: 'TC02', descrizione: 'Cassa previdenza dottori commercialisti' },
  { id: 'TC03', descrizione: 'Cassa previdenza e assistenza geometri' },
  {
    id: 'TC04',
    descrizione:
      'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
  },
  { id: 'TC05', descrizione: 'Cassa nazionale del notariato' },
  {
    id: 'TC06',
    descrizione:
      'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
  },
  {
    id: 'TC07',
    descrizione:
      'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
  },
  {
    id: 'TC08',
    descrizione:
      'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
  },
  {
    id: 'TC09',
    descrizione: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
  },
  {
    id: 'TC10',
    descrizione: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
  },
  {
    id: 'TC11',
    descrizione: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
  },
  {
    id: 'TC12',
    descrizione:
      "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
  },
  {
    id: 'TC13',
    descrizione:
      'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
  },
  {
    id: 'TC14',
    descrizione: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
  },
  {
    id: 'TC15',
    descrizione: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
  },
  {
    id: 'TC16',
    descrizione:
      'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
  },
  {
    id: 'TC17',
    descrizione:
      'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
  },
  {
    id: 'TC18',
    descrizione: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
  },
  {
    id: 'TC19',
    descrizione: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
  },
  {
    id: 'TC20',
    descrizione:
      'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
  },
  {
    id: 'TC21',
    descrizione: 'Ente nazionale previdenza e assistenza psicologi(ENPAP)',
  },
  { id: 'TC22', descrizione: 'INPS' },
];

interface MapMacroGruppiSottoGruppi {
  macroGruppo: DocID;
  sottoGruppo: string;
}

export const DocumentiMapMacroGruppiSottoGruppi: MapMacroGruppiSottoGruppi[] = [
  { macroGruppo: DFVE, sottoGruppo: DFVE_FAAP },
  { macroGruppo: DFVE, sottoGruppo: DFVE_FATT },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUAI },
  { macroGruppo: DFVE, sottoGruppo: DFVE_FAAC },
  { macroGruppo: DFVE, sottoGruppo: DFVE_PAAC },
  { macroGruppo: DFVE, sottoGruppo: DFVE_NOAC },
  { macroGruppo: DFVE, sottoGruppo: DFVE_NODE },
  { macroGruppo: DFVE, sottoGruppo: DFVE_PARC },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AURG },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUAS },
  { macroGruppo: DFVE, sottoGruppo: DFVE_BEIN },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUEU },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUAD },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUSP },
  { macroGruppo: DFVE, sottoGruppo: DFVE_ESIV },
  { macroGruppo: DFVE, sottoGruppo: DFVE_ESVV },
  { macroGruppo: DFVE, sottoGruppo: DFVE_FAD1 },
  { macroGruppo: DFVE, sottoGruppo: DFVE_FAD2 },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUBA },
  { macroGruppo: DFVE, sottoGruppo: DFVE_AUOM },
  { macroGruppo: DFVE, sottoGruppo: DFVE_FASM },
  { macroGruppo: DFAC, sottoGruppo: DFAC_TEFA_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_TENA_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_STIP_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_TASS_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_ALTR_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_STAT_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAPR_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAAP },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FATT },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAI },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAAP_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FATT_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAI_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAAC },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAAC_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_PAAC },
  { macroGruppo: DFAC, sottoGruppo: DFAC_PAAC_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_NOAC },
  { macroGruppo: DFAC, sottoGruppo: DFAC_NOAC_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_NODE },
  { macroGruppo: DFAC, sottoGruppo: DFAC_NODE_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_PARC },
  { macroGruppo: DFAC, sottoGruppo: DFAC_PARC_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AURG },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AURG_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAS },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAS_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_BEIN },
  { macroGruppo: DFAC, sottoGruppo: DFAC_BEIN_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUEU },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUEU_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAD },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUAD_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUSP },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUSP_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_ESIV },
  { macroGruppo: DFAC, sottoGruppo: DFAC_ESIV_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_ESVV },
  { macroGruppo: DFAC, sottoGruppo: DFAC_ESVV_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAD1 },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAD1_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAD2 },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FAD2_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUBA },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUBA_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUOM },
  { macroGruppo: DFAC, sottoGruppo: DFAC_AUOM_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FASM },
  { macroGruppo: DFAC, sottoGruppo: DFAC_FASM_C },
  { macroGruppo: DFAC, sottoGruppo: DFAC_SCRI_C },
  { macroGruppo: ORDC, sottoGruppo: ORDC_ORDI },
  { macroGruppo: DDTV, sottoGruppo: DDTV_DDTV },
  { macroGruppo: DDTV, sottoGruppo: DDTV_CAIN },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RESO },
  { macroGruppo: DDTV, sottoGruppo: DDTV_COVI },
  { macroGruppo: DDTV, sottoGruppo: DDTV_CODE },
  { macroGruppo: DDTV, sottoGruppo: DDTV_COLA },
  { macroGruppo: DDTV, sottoGruppo: DDTV_TEVE },
  { macroGruppo: DDTV, sottoGruppo: DDTV_COVE },
  { macroGruppo: DDTV, sottoGruppo: DDTV_COSC },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RIPA },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RCLA },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RCVI },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RACC },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RSOS },
  { macroGruppo: DDTV, sottoGruppo: DDTV_RRIP },
  { macroGruppo: DDTV, sottoGruppo: DDTV_OMAG },
  { macroGruppo: DDTA, sottoGruppo: DDTA_DDTA },
  { macroGruppo: ORDF, sottoGruppo: ORDF_ORDI },
  { macroGruppo: PREV, sottoGruppo: PREV_PREV },
  { macroGruppo: RETT, sottoGruppo: RETT_RETT },
  { macroGruppo: FAPR, sottoGruppo: FAPR_FAPR },
];

export const DocumentiSottoGruppiWithoutSconto = [
  DFVE_NOAC,
  DFVE_AUAD,
  DFVE_AUOM,
  DFVE_AUEU,
  DFVE_AUAI,
  DFVE_AURG,
  DFVE_AUAS,
  DFVE_AUSP,
  DFVE_BEIN,
  DFVE_ESIV,
  DFVE_ESVV,
  DFVE_AUBA,
  DFVE_FASM,
];

export const INVIO_STATO_DI = 'DI';
export const INVIO_STATO_WCRE = 'WCRE';
export const INVIO_STATO_WINV = 'WINV';
export const INVIO_STATO_IN = 'IN';
export const INVIO_STATO_NS = 'NS';
export const INVIO_STATO_RC = 'RC';
export const INVIO_STATO_MC = 'MC';
export const INVIO_STATO_DT = 'DT';
export const INVIO_STATO_EC01 = 'EC01';
export const INVIO_STATO_EC02 = 'EC02';
export const INVIO_STATO_ERR = 'ERR';
export const INVIO_STATO_IMP = 'IMP';
export const INVIO_STATO_ERR_SDI = 'ERR_SDI';

export const DocumentoInvioStato: KeyValue[] = [
  { id: INVIO_STATO_DI, descrizione: 'Da Inviare' },
  { id: INVIO_STATO_WCRE, descrizione: 'Creazione in corso' },
  { id: INVIO_STATO_WINV, descrizione: 'Invio in corso' },
  { id: INVIO_STATO_IN, descrizione: 'Inviato' },
  { id: INVIO_STATO_NS, descrizione: 'Notifica di scarto' },
  { id: INVIO_STATO_RC, descrizione: 'Inviata e consegnata' },
  { id: INVIO_STATO_MC, descrizione: 'Inviata correttamente' },
  { id: INVIO_STATO_DT, descrizione: 'Decorrenza termini' },
  { id: INVIO_STATO_EC01, descrizione: 'Accettata' },
  { id: INVIO_STATO_EC02, descrizione: 'Rifiutata' },
  { id: INVIO_STATO_ERR, descrizione: 'Errore' },
  { id: INVIO_STATO_ERR_SDI, descrizione: 'Problema SDI' },
  { id: INVIO_STATO_IMP, descrizione: 'Importata' },
];

export const DocumentoInvioStatoToObserve: string[] = ['WCRE', 'WINV', 'IN'];
export const DocumentoInvioStatoToExclude: string[] = [
  'WCRE',
  'WINV',
  'ERR_SDI',
];
export const DocumentoInvioStatoToUpdate: KeyValue[] = [
  ...DocumentoInvioStato.filter(
    (el) => !DocumentoInvioStatoToExclude.includes(String(el.id)),
  ),
];

export const DocumentoInvioStatoNotDelete: string[] = [
  'WCRE',
  'WINV',
  'IN',
  'NS',
  'RC',
  'MC',
  'DT',
  'EC01',
  'EC02',
];

export const INVIO_STATO_EDIT = ['DI', 'NS', 'ERR', 'ERR_SDI', 'NG'];

export const DocumentoRitenutaStato: KeyValue[] = [
  { id: '', descrizione: '' },
  { id: 'NL', descrizione: 'Non liquidabile' },
  { id: 'LI', descrizione: 'Liquidabile' },
  { id: 'LQ', descrizione: 'Liquidata' },
];

export const NON_SALDATO = 'N';
export const PARZIALE = 'P';
export const SALDATO = 'S';

export const DocumentoPagamentoStato: KeyValue[] = [
  { id: NON_SALDATO, descrizione: 'Non Saldato' },
  { id: PARZIALE, descrizione: 'Parziale' },
  { id: SALDATO, descrizione: 'Saldato' },
];

export const DocumentoCondizioniPagamentoFe: KeyValue[] = [
  { id: '', descrizione: 'Automatico' },
  { id: 'TP01', descrizione: 'Pagamento a rate' },
  { id: 'TP02', descrizione: 'Pagamento completo' },
  { id: 'TP03', descrizione: 'Anticipo' },
];

export const SC = 'SC';
export const RA = 'RA';
export const SF = 'SF';

export const DocumentoScadenzaTipo: KeyValue[] = [
  { id: SC, descrizione: 'Rata' },
  { id: RA, descrizione: 'Ritenuta acconto' },
  { id: SF, descrizione: 'Sconto Finanziario' },
];

export const DocumentoScadenzaRataAnnullata = 'Rata annullata';

export const DP = 'DP';
export const PA = 'PA';
export const CP = 'CP';
export const CC = 'CC';

export const DocumentoScadenzaIncassoStato: KeyValue[] = [
  {
    id: PA + '_PR',
    descrizione: 'Incassa e registra operazione in prima nota',
  },
  { id: PA, descrizione: 'Incassa ma non registrare operazione in prima nota' },
  { id: CP, descrizione: 'Incassa per compensazione' },
  { id: CC, descrizione: 'Cessione credito' },
];

export const DocumentoScadenzaIncassoStatoAcquisto: KeyValue[] = [
  {
    id: PA + '_PR',
    descrizione: 'Marca Pagata e registra operazione in prima nota',
  },
  {
    id: PA,
    descrizione: 'Marca Pagata ma non registrare operazione in prima nota',
  },
  { id: CP, descrizione: 'Marca Pagata per compensazione' },
];

export const DocumentoScadenzaPresentazione: KeyValue[] = [
  { id: '1', descrizione: 'Rata da presentare' },
  { id: '0', descrizione: 'Non presentare' },
];

export const PAID_STATE = [PA, CP, CC];

export const DocumentoScadenzaStato: KeyValue[] = [
  { id: DP, descrizione: 'Da pagare' },
  { id: PA, descrizione: 'Pagata' },
  { id: CP, descrizione: 'Compensazione' },
  { id: CC, descrizione: 'Cessione credito' },
];

export const SCADENZA_STATO_INSOLUTO = 'Insoluto';
export const SCADENZA_STATO_LIQUIDABILE = 'Liquidabile';

export const DOCUMENTO_STATO_CHIUSO = 'CHI';
export const DOCUMENTO_STATO_APERTO = 'APE';
export const DOCUMENTO_STATO_ANNULLATO = 'ANN';

export const DocumentoStatoProforma: KeyValue[] = [
  { id: DOCUMENTO_STATO_CHIUSO, descrizione: 'Chiuso' },
  { id: DOCUMENTO_STATO_APERTO, descrizione: 'Aperto' },
  { id: DOCUMENTO_STATO_ANNULLATO, descrizione: 'Annullato' },
];

export const DocumentoStato: KeyValue[] = [
  { id: DOCUMENTO_STATO_CHIUSO, descrizione: 'Chiuso' },
  { id: DOCUMENTO_STATO_APERTO, descrizione: 'Aperto' },
];

export const DocumentoTrasportoResaTipo: KeyValue[] = [
  { id: '', descrizione: '' },
  { id: 'EXW', descrizione: 'EXW' },
  { id: 'FCA', descrizione: 'FCA' },
  { id: 'FOB', descrizione: 'FOB' },
  { id: 'FAS', descrizione: 'FAS' },
  { id: 'CFR', descrizione: 'CFR' },
  { id: 'CIF', descrizione: 'CIF' },
  { id: 'CPT', descrizione: 'CPT' },
  { id: 'CIP', descrizione: 'CIP' },
  { id: 'DAT', descrizione: 'DAT' },
  { id: 'DAP', descrizione: 'DAP' },
  { id: 'DDP', descrizione: 'DDP' },
];

export const DocumentoBolloVirtuale: KeyValue[] = [
  { id: '', descrizione: 'Utilizza regola impostata sui documenti' },
  { id: 'NO', descrizione: 'No' },
  { id: 'AU', descrizione: 'Automatico' },
];

export const DocumentoAutofatturaModalita: KeyValue[] = [
  { id: '', descrizione: 'Non invertire' },
  { id: 'INV_CC_CP', descrizione: 'Inverti cessionario e cedente' },
];

export const DocumentiOperazioniFE: KeyValue[] = [
  { id: 'INV', descrizione: 'Invio fatture elettroniche' },
  { id: 'XML', descrizione: 'Solo generazione XML' },
];

export const DocumentiOperazioniExport: KeyValue[] = [
  { id: 'INV', descrizione: 'Invia file XML tramite email' },
  { id: 'XML', descrizione: 'Download XML' },
];

export const DocumentiOperations = [
  URL_OPERATION_XML,
  URL_OPERATION_INV,
  URL_OPERATION_EXP,
];

export type DocumentiOperationsType = (typeof DocumentiOperations)[number];

export const XML_ESPORTATO_SI = 'SI';
export const XML_ESPORTATO_NO = 'NO';
export const XML_ESPORTATO_WOR = 'WOR';

export const FormatoDocumento: KeyValue[] = [
  { id: 'C', descrizione: 'Cartaceo' },
  { id: 'E', descrizione: 'Elettronico' },
];

export const checkCanShowMovimentazioneAttiva = (
  doc: DocID,
  tipoSub: string,
) => {
  const docNotIncludes = [ORDF, ORDC, PREV, FAPR];
  const tipoSubIncludes = [
    DFVE_PARC,
    DFVE_PAAC,
    DFVE_AURG,
    DFVE_AUAS,
    DFVE_AUEU,
    DFVE_AUAD,
    DFVE_AUSP,
    DFVE_AUAI,
    DFVE_AUOM,
    DFAC_STIP_C,
    DFAC_TASS_C,
    DFAC_ALTR_C,
    DFAC_SCRI_C,
    DFAC_PARC_C,
    DFAC_PAAC_C,
    DFAC_AURG_C,
    DFAC_AUAS_C,
    DFAC_AUEU_C,
    DFAC_AUSP_C,
    DFAC_AUOM_C,
    DFAC_AUAI_C,
    DFAC_AUAD_C,
    DFAC_PAAC,
    DFAC_PARC,
    DFAC_AUAI,
    DFAC_AURG,
    DFAC_AUAS,
    DFAC_AUEU,
    DFAC_AUAD,
    DFAC_AUSP,
    DFAC_AUOM,
  ];
  return !(
    (doc && docNotIncludes.includes(doc)) ||
    (tipoSub && tipoSubIncludes.includes(tipoSub))
  );
};

export const InserimentoDettagliatoRighe: KeyValue[] = [
  { id: 'true', descrizione: 'INSERIMENTO DETTAGLIATO DELLE RIGHE' },
  { id: 'false', descrizione: 'INSERIMENTO RIEPILOGATIVO DEL DOCUMENTO' },
];

export const TipoSubDdtv: KeyValue[] = [
  { id: DDTV_DDTV, descrizione: DDT_VENDITA },
  { id: DDTV_CAIN, descrizione: DDT_TRASPORTO_CANTIERE },
  { id: DDTV_RESO, descrizione: DDT_RESO_CANTIERE },
  { id: DDTV_COVI, descrizione: DDT_CONTO_VISIONE },
  { id: DDTV_CODE, descrizione: DDT_CONTO_DEPOSITO },
  { id: DDTV_COVE, descrizione: DDT_CONTO_VENDITA },
  { id: DDTV_COLA, descrizione: DDT_CONTO_LAVORAZIONE },
  { id: DDTV_TEVE, descrizione: DDT_TENTATA_VENDITA },
  { id: DDTV_COSC, descrizione: DDT_CONTO_SCAMBIO },
  { id: DDTV_RIPA, descrizione: DDT_RIPARAZIONE },
  { id: DDTV_RCLA, descrizione: DDT_RESO_CONTO_LAVORAZIONE },
  { id: DDTV_RCVI, descrizione: DDT_RESO_CONTO_VISIONE },
  { id: DDTV_RACC, descrizione: DDT_RESO_PER_ACCREDITO },
  { id: DDTV_RSOS, descrizione: DDT_RESO_PER_SOSTITUZIONE },
  { id: DDTV_RRIP, descrizione: DDT_RESO_DA_RIPARAZIONE },
  { id: DDTV_OMAG, descrizione: DDT_OMAGGIO },
];

export interface DdtVenditaTipo {
  id: string;
  fatturabile_massivamente: boolean;
  stato_attivo: boolean;
  autointestato: boolean;
}

export const TipoDdtVendita: DdtVenditaTipo[] = [
  {
    id: DDTV_DDTV,
    fatturabile_massivamente: true,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_CAIN,
    fatturabile_massivamente: false,
    stato_attivo: false,
    autointestato: true,
  },
  {
    id: DDTV_RESO,
    fatturabile_massivamente: false,
    stato_attivo: false,
    autointestato: true,
  },
  {
    id: DDTV_COVI,
    fatturabile_massivamente: true,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_CODE,
    fatturabile_massivamente: false,
    stato_attivo: false,
    autointestato: false,
  },
  {
    id: DDTV_COVE,
    fatturabile_massivamente: true,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_COLA,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_TEVE,
    fatturabile_massivamente: true,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_COSC,
    fatturabile_massivamente: false,
    stato_attivo: false,
    autointestato: false,
  },
  {
    id: DDTV_RIPA,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_RCLA,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_RCVI,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_RACC,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_RSOS,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_RRIP,
    fatturabile_massivamente: false,
    stato_attivo: true,
    autointestato: false,
  },
  {
    id: DDTV_OMAG,
    fatturabile_massivamente: true,
    stato_attivo: true,
    autointestato: false,
  },
];
